import { useDistributions, useTargets } from '@/api/hooks.js';
import { DistributionList } from '@/components/DistributionList.js';
import { EmptyState, ErrorNotice, Loading, SectionHeading } from '@/components/ui.js';

/** Every distribution for the current tenant, newest first. */
export function HistoryPage() {
  const distributions = useDistributions();
  // Deactivated targets included, so a removed destination still resolves on
  // the runs that used it.
  const targets = useTargets(true);

  if (distributions.isLoading) return <Loading label="Loading history…" />;
  if (distributions.error) return <ErrorNotice error={distributions.error} />;

  return (
    <div>
      <SectionHeading title="Distribution history" />

      {distributions.data?.distributions.length === 0 ? (
        <EmptyState title="Nothing distributed yet" />
      ) : (
        <DistributionList
          distributions={distributions.data?.distributions ?? []}
          targets={targets.data?.targets ?? []}
          linkBase="/admin/history"
        />
      )}
    </div>
  );
}
